export const UPDATE_POOL_REQUEST_REQUEST = 'UPDATE_POOL_REQUEST_REQUEST';

export const updatePoolRequestRequest = ( id, updateData ) => ({
    type: UPDATE_POOL_REQUEST_REQUEST,
    payload: {
        id,
        updateData
    }
});
